<template>
  <div id="history_root" :class="'history root'" :key="changeCount">
    <div class="listData px-3">
      <div class="history-title-container">
        <span class="history-title">ประวัติการแลกของรางวัล</span>
        <!-- <a class="view-all" @click="viewHistory">ดูทั้งหมด
          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
              d="M6.00839 7.49034C6.10689 7.49105 6.20442 7.47088 6.29452 7.43117C6.39135 7.38592 6.4768 7.31964 6.5446 7.23717L11.8068 1.33944C11.9466 1.19209 12.0222 0.995481 12.017 0.792655C12.0192 0.653666 11.9869 0.516295 11.9232 0.392682C11.8633 0.277064 11.7746 0.17878 11.6656 0.107308C11.5572 0.0359325 11.4298 -0.00137663 11.2998 0.000199319C11.2031 0.000701433 11.1077 0.0222006 11.0202 0.0632038C10.9326 0.104207 10.8551 0.16373 10.7929 0.237636L6.00839 5.59608L1.22385 0.238386C1.1617 0.16448 1.08417 0.104957 0.996627 0.0639538C0.909088 0.0229506 0.813646 0.0014505 0.716935 0.000947922C0.585717 -0.00166705 0.456819 0.0356989 0.347449 0.108057C0.24043 0.180511 0.1534 0.278646 0.0943666 0.393432C0.0306189 0.517045 -0.00162177 0.654415 0.000493175 0.793406C-0.00468357 0.996231 0.0709269 1.19284 0.21077 1.34019L5.47294 7.23642C5.54074 7.31889 5.62619 7.38518 5.72302 7.43042C5.81283 7.47028 5.91009 7.49071 6.00839 7.49034Z" 
              fill="#006B2F"
            />
          </svg>
        </a> -->
      </div>
      <SearchInput
        :keyword="keyword"
        :updateKeyword="updateKeyword"
        :placeholder="'ค้นหา'"
      />
      <div class="item-container">
        <div
            v-for="(it, index) in generateList"
            :key="index"
            :class="'row redeem-item'"
            v-on:click="it.status == 'redeemed' && it.categoryId !== 24 ? itemClick(it) : ''"
            data-tag="redeem-item"
          >
            <div class="col-5 p-0 rw_image">
              <img width="100%" v-lazy="it.imageUrl" alt />
            </div>
            <div class="col des p-0">
              <div class="font-weight-bold title-clamp">
                {{ it.title }}
              </div>
              <div style="color: #707070;">
                {{ dateTolocal(it.createdAt) }} | {{ formatTimeThai(it.createdAt) }}
              </div>
              <div class="font-weight-bold d-flex align-items-center point">
                <img :src="require('@/assets/icon/BevFamilyPoint.png')" alt="bev point" width="24" height="24" class="mr-1"/>
                {{ $toLocal(it.spentPoint) }}
              </div>
              <div>
                <span v-if="it.type == 'luckydraw'">
                  <i class="icon-ok-circled received"></i> คะแนนที่ใช้แลกสิทธิ์
                </span>
                <template v-else-if="it.categoryId !== 24">
                  <span v-if="it.status == 'redeemed'">
                    <i class="icon-truck redeemed"></i> อยู่ระหว่างการจัดส่ง
                  </span>
                  <span v-else-if="it.status == 'received'">
                    <i class="icon-ok-circled received"></i> จัดส่งของรางวัลแล้ว
                  </span>
                </template>
              </div>
            </div>
          </div>
        <infinite-loading
          v-if="dataStage != 'error'"
          @infinite="getRedemptions"
          force-use-infinite-wrapper="false"
          ref="infiniteLoading"
          spinner="waveDots"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
      <div v-if="dataStage == 'loading'" class="skeleton-container">
        <vue-content-loading
          v-for="i in 6"
          :key="i + '_'"
          :width="100"
          :height="130"
        >
          <rect y="25" rx="15" ry="15" width="37%" height="80%" />
          <rect y="30" x="40%" rx="4" ry="4" width="40%" height="15" />
          <rect y="55" x="40%" rx="4" ry="4" width="60%" height="15" />
          <rect y="80" x="40%" rx="4" ry="4" width="30%" height="15" />
          <rect y="105" x="40%" rx="4" ry="4" width="50%" height="15" />
        </vue-content-loading>
      </div>
      <div v-if="dataStage == 'error'" class="text-center pt-4">
        Coming soon!
      </div>
      <div v-if="dataStage == 'nodata'" class="text-center pt-4">
        Coming soon
      </div>
    </div>

    <b-modal id="confirmReceived_modal" hide-footer centered>
      <template v-slot:modal-header-close>
        <i class="close-modal icon-cancel-circled-outline"></i>
      </template>
      <div class="confirm-receive-content">
        <h4 class="text-center">รายละเอียดข้อมูลในการแลกสิทธิ์</h4>
        <div class="row redeem-item" v-if="modal_data">
          <div class="col-5 p-0 rw_image">
            <img width="100%" v-lazy="modal_data.imageUrl" alt />
          </div>
          <div class="col des p-0">
            <div class="font-weight-bold title-clamp">
              {{ modal_data.title }}
            </div>
            <div style="color: #707070;">
              {{ dateTolocal(modal_data.createdAt) }} | {{ formatTimeThai(modal_data.createdAt) }}
            </div>
            <div class="font-weight-bold d-flex align-items-center point">
              <img :src="require('@/assets/icon/BevFamilyPoint.png')" alt="bev point" width="24" height="24" class="mr-1"/>
              {{ $toLocal(modal_data.spentPoint) }}
            </div>
            <div :class="modal_data.status">
              <span v-if="modal_data.status == 'redeemed'">
                <i class="icon-truck"></i> อยู่ระหว่างการจัดส่ง
              </span>
              <span v-if="modal_data.status == 'received'">
                <i class="icon-ok-circled"></i> จัดส่งของรางวัลแล้ว
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="confirm-receive-buttons">
        <button
          v-if="!confirmLoading"
          id="okBtn"
          class="btn btn-primary w-100"
          :disabled="$readOnly"
          @click="recievedClick(modal_data.id)"
          data-tag="recieved"
        >
          <span>รับสินค้าแล้ว</span>
        </button>
        <button
          v-if="confirmLoading"
          class="btn btn-primary w-100"
          type="button"
          disabled
        >
          <span
            class="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span>&nbsp;Loading...</span>
        </button>
        <button
          id="okBtn"
          class="btn btn-light w-100"
          @click="$bvModal.hide('confirmReceived_modal')"
          data-tag="back"
        >
          กลับ
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import VueContentLoading from "vue-content-loading";
import InfiniteLoading from "vue-infinite-loading";
import SearchInput from "@/components/SearchInput";

export default {
  name: "history",
  components: { VueContentLoading, InfiniteLoading, SearchInput },
  data() {
    return {
      dataStage: "loading",
      next_page_url: `${process.env.VUE_APP_API_URL}/redemptions?page=1`,
      redeemData: [],
      modal_data: null,
      confirmLoading: false,
      changeCount: 0,
      keyword: "",
    };
  },
  methods: {
    updateKeyword(e) {
      this.keyword = e.target?.value;
    },
    searchKeyword(list, keyword) {
      let searchList = [];
      list.forEach((i) => {
        const { title } = i;

        if (title.toLowerCase().includes(keyword.toLowerCase())) {
          searchList.push(i);
        }
      });
      return searchList;
    },
    async fetchRedemptions() {
      return await fetch(this.next_page_url, {
        method: "GET",
        headers: { Authorization: `Bearer ${this.$JWT}` },
      });
    },
    async getRedemptions($state) {
      try {
        const res = await this.fetchRedemptions();
        console.log("fetchRedemptions status:", res.status);
        if (res.status === 200) {
          const body = await res.json();
          this.next_page_url = body.nextPageUrl;
          this.redeemData = this.redeemData.concat(body.data || []);
          if (this.redeemData.length === 0) {
            this.dataStage = "nodata";
            this.$nextTick(() => { $state.complete(); });
            return;
          }
          if (body.currentPage >= body.lastPage) {
            this.dataStage = "end";
            this.$nextTick(() => { $state.complete(); });
          } else {
            this.dataStage = "already";
            this.$nextTick(() => { $state.loaded(); });
          }
        } else {
          this.dataStage = "error";
          this.$nextTick(() => { $state.complete(); });
        }
      } catch (error) {
        console.log(error);
        this.dataStage = "error";
        this.$nextTick(() => { $state.complete(); });
      }
    },
    dateTolocal(val) {
      return new Date(val)
        .toLocaleString("en-GB", { timeZone: "UTC" })
        .split(",")[0];
    },
    formatTimeThai(dateValue) {
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) return "";

      const time = date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return `${time} น.`;
    },
    itemClick(data) {
      this.modal_data = data;
      this.$nextTick(() => {
        this.$bvModal.show("confirmReceived_modal");
      });
    },
    async fetchRedemptionConfirm(redemptionID) {
      return await fetch(
        `${process.env.VUE_APP_API_URL}/redemption/${redemptionID}/confirm`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.$JWT}`,
          },
        }
      );
    },
    async recievedClick(redemptionID) {
      this.confirmLoading = true;
      try {
        const res = await this.fetchRedemptionConfirm(redemptionID);
        console.log("fetchRedemptionConfirm status:", res.status);

        let body = [];
        switch (res.status) {
          case 200:
            {
              body = await res.json();
              this.messageComfirm(body);
              window.$pushEvent("redemption", "confirm", body);
            }
            break;
          default:
            throw "no case " + res.status;
        }
      } catch (error) {
        console.log(error);
        this.$Error();
        window.$pushEvent("redemption", "error", error);
      } finally {
        this.confirmLoading = false;
      }
    },
    messageComfirm(status) {
      switch (status) {
        case "CONFIRM_DELIVERY":
          this.Swal.fire("ยืนยันการรับของสำเร็จ", "", "success").then(() => {
            //this.$forceUpdate();

            this.changeCount += 1;
            this.$bvModal.hide("confirmReceived_modal");
            this.dataStage = "loading";
            this.next_page_url = `${process.env.VUE_APP_API_URL}/redemptions?page=1`;
            this.redeemData = [];
            this.modal_data = null;
            this.confirmLoading = false;
            this.$refs.infiniteLoading.stateChanger.reset();
          });
          break;
        default:
          this.$Error();
          window.$pushEvent("redemption", "error", status);
      }
    },
    viewHistory() {
      console.log('view history')
    }
  },
  computed: {
    generateList() {
      const { keyword, redeemData } = this;
      if (keyword) {
        return this.searchKeyword(redeemData, keyword);
      }
      return redeemData;
    },
  },
  watch: {
    dataStage(val) {
      const elm = document.getElementById("history_root");
      if (val == "loading") {
        elm.classList.add("position-fixed");
      } else {
        elm.classList.remove("position-fixed");
      }
    },
  },
  async mounted() {
    window.loading(false);
  },
};
</script>

<style  scoped>
.root {
  font-size: 16px;
  background-color: white;
  overflow-x: hidden;
  width: 100%;
}

.item-container {
  margin: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.skeleton-container {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.redeem-item {
  display: flex;
  padding: 12px;
  gap: 8px;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  min-height: 135px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 0 4px 0 #00000040;
}

.order-type {
  font-weight: bold;
  line-height: 21px;
}

.order-type-1 {
  color: #15B766
}

.order-type-2 {
  color: #005DD6
}

.order-type-3 {
  color: #F59300
}

.rw_image {
  border-radius: 10px;
  overflow: hidden;
}

.des {
  font-size: 14px;
  line-height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
}

i {
  font-size: 16px;
}

.received {
  color: rgb(64, 125, 128);
}

.redeemed {
  color: rgb(124, 173, 67);
}

.spinner-grow {
  vertical-align: middle;
}

.point {
  font-size: 18px;
}

.title-clamp {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.history-title-container {
  display: flex;
  margin: 16px 0;
  justify-content: space-between;
}

.history-title {
  font-size: 20px;
  line-height: 30px;
  font-weight: bold;
}

.view-all {
  color: #006b2f;
  text-decoration: none;
  cursor: pointer;
  font-size: 14;
  line-height: 21px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.confirm-receive-content {
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 10px;
}

.confirm-receive-buttons {
  display: flex;
  margin: -6px;
  margin-top: 0;
  gap: 12px;
}

@media screen and (max-width: 400px) {
  .root {
    font-size: 12px;
  }
  .des {
    font-size: 12px;
  }
}
</style>
